<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary align-items-center">
          <h4 class="modal-title">
            <span>
              <slot name="title"> </slot>
            </span>
          </h4>
          <div
            class="button-add-wrapper"
            data-toggle="tooltip"
            data-placement="left"
            title=""
            data-original-title="Fermer"
          >
            <a
              href="#"
              @click="hideModal"
              data-dismiss="modal"
              aria-label="Close"
              class="btn btn-primary button-create pb-1 pl-2 pr-2"
            >
              <i class="fa fa-square-xmark text-lg" style="font-size: 1.3rem !important"></i>
            </a>
          </div>
        </div>
        <div class="modal-body">
          <slot name="content"> </slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn btn-default bg-secondary" @click="hideModal">
              {{ $t('crud.cancel') }}
            </button>
            <button type="submit" class="btn btn-default bg-danger" @click="submitDeleteAction">
              {{ $t('crud.delete') }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteModal',
  emits: ['deleteRecord', 'hideModal'],
  props: {
    title: {
      type: String,
      default: "Suppression d'un enregistrement"
    }
  },
  methods: {
    submitDeleteAction() {
      this.$emit('deleteRecord')
    },
    hideModal() {
      this.$emit('hideModal')
    }
  }
}
</script>

<style></style>
